import React, { Fragment, useState, useEffect } from "react";
import Table, {
  AvatarCell,
  SelectColumnFilter,
  StatusPill,
} from "../../table/Table"; // new
import {getAuthorization} from "../../../axios/AxiosAut";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setAPIDetailsGroupTable } from "../../../redux/slices/statistics/statisticSlice";
import { Dialog, Transition } from "@headlessui/react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";

function GroupsTableData() {
  const navigate = useNavigate();
  const [Groups, setGroups] = useState([]);
  const APIDetailsGroupTable = useSelector(
    (state) => state.statistics.APIDetailsGroupTable
  );
  const dispatch = useDispatch();

  const GroupValidationSchema = Yup.object({
    group_name: Yup.string()
      .min(2, "Too short!")
      .max(20, "Too long!")
      .required("Required"),
    group_description: Yup.string()
      .min(2, "Too short!")
      .max(40, "Too long!")
      .required("Required"),
  });
  const [open, setOpen] = useState(false);

  const CreateGroupInitialValues = {
    group_name: "",
    group_description: "",
  };

  const GroupModelHandler = () => {
    setOpen(true);
  };
  const HandleSubmitCreateGroup = (values, onSubmitProps) => {
    getAuthorization()
      .post("company/group_create/", values)
      .then((res) => {
        console.log("values", values);
        setOpen(false);
        onSubmitProps.setSubmitting(false);
        // setTimeout(() => {
        //   ShowGroupNotification();
        // }, 1000);
        getGroupdata();
      })
      .catch((err) => {
        console.log("Error in creating group", err);
        onSubmitProps.setSubmitting(false);
      });
  };

  const getGroupdata = () => {
    getAuthorization()
      .get("company/all_groups/")
      .then((res) => {
        setGroups(res.data.result);
        dispatch(setAPIDetailsGroupTable(res.data.result));
      })
      .catch((err) => {
        console.log("Error in getting company groups", err);
      });
  };
  useEffect(() => {
    //Get user groups
    if (APIDetailsGroupTable.length === 0) {
      getGroupdata();
      console.log("Inside group useeffect");
    }
  }, []);

  const ActionHandler = (ID) => {
    navigate("/dashboard/management/company-staff/group-details", {
      state: ID,
    });
  };
  const data = APIDetailsGroupTable;
  const columns = React.useMemo(
    () => [
      {
        Header: "Group Name",
        accessor: "name",
      },
      {
        Header: "Description",
        accessor: "descriptions",
        // Cell: StatusPill,
      },
      {
        Header: "Action",
        // accessor: "action",
        id: "edit",
        accessor: "name",
        Cell: (value) => (
          <button onClick={() => ActionHandler(value.row.original.id)}>
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15 12.1815C15 13.8391 13.654 15.1881 12 15.1881C10.346 15.1881 9 13.8391 9 12.1815C9 10.5239 10.346 9.17498 12 9.17498C13.654 9.17498 15 10.5239 15 12.1815ZM24 11.7315C24 11.7315 19.748 20.199 12.015 20.199C4.835 20.199 0 11.7315 0 11.7315C0 11.7315 4.446 4.16406 12.015 4.16406C19.709 4.16406 24 11.7315 24 11.7315ZM17 12.1815C17 9.41851 14.757 7.17061 12 7.17061C9.243 7.17061 7 9.41851 7 12.1815C7 14.9445 9.243 17.1924 12 17.1924C14.757 17.1924 17 14.9445 17 12.1815Z"
                fill="#1F78B4"
              />
            </svg>

            {/* <FaEdit size={25} color="#3887BC" /> */}
          </button>
        ),
      },
    ],
    []
  );

  return (
    <div className="min-h-screen">
      <main className="max-w-full px-4 sm:px-6 lg:px-8 pt-4">
        <div className="mt-1">
          <Table columns={columns} data={data} text="Undefined" />
        </div>
      </main>
    </div>
  );
}

export default GroupsTableData;
